module.exports = __webpack_public_path__ + "static/media/twitter_verified.9fa42fd5.png";